import { createFileRoute } from "@tanstack/react-router";
import AdminUserDetailPage from "@/admin/pages/user-detail";
import { isStatusTab, type StatusTab } from "@/admin/pages/users";

export const USER_DETAIL_TABS = [
  "overview",
  "email-log",
  "notifications",
  "activity",
  "cards",
  "reminders",
  "requests",
  "billing",
  "audit",
] as const;
export type UserDetailTab = (typeof USER_DETAIL_TABS)[number];

/**
 * `tab` keeps the open tab across reloads and Back; `grant=offline` opens Add premium.
 *
 * The `l*` keys are the users-list filters the row was clicked from — prefixed so they
 * can't collide with this page's own `tab`. `ltab` is always sent, so its presence is
 * what tells the header it has a list to walk with Previous / Next.
 */
export type UserDetailSearch = {
  tab?: UserDetailTab;
  grant?: "offline";
  lq?: string;
  lln?: string;
  lfn?: string;
  lbd?: string;
  lpo?: boolean;
  ltab?: StatusTab;
};

const str = (v: unknown): string | undefined => (typeof v === "string" && v ? v : undefined);

export const Route = createFileRoute("/admin/users/$id")({
  component: AdminUserDetailPage,
  validateSearch: (search: Record<string, unknown>): UserDetailSearch => ({
    tab: USER_DETAIL_TABS.includes(search.tab as UserDetailTab)
      ? (search.tab as UserDetailTab)
      : undefined,
    grant: search.grant === "offline" ? "offline" : undefined,
    lq: str(search.lq),
    lln: str(search.lln),
    lfn: str(search.lfn),
    lbd: str(search.lbd),
    lpo: search.lpo === true || search.lpo === "true" ? true : undefined,
    ltab: isStatusTab(search.ltab) ? search.ltab : undefined,
  }),
});
